import Alternatives     from './target/Alternatives'
import EngineDropdown   from './target/EngineDropdown'
import LimitWarning     from './target/LimitWarning'
import LoadingDots      from './target/LoadingDots'
import TargetCopyButton from './target/TargetCopyButton'
import TargetSentence   from './target/TargetSentence'

import Segmenter from './helpers/Segmenter'

export default class Target extends React.PureComponent
  constructor: (props) ->
    super(props)

    @state =
      languageCode:  undefined # will be added by getDerivedStateFromProps
      intlSegmenter: undefined # will be added by getDerivedStateFromProps

    @handleKeyboardEvent = @handleKeyboardEvent.bind(this)

  # To avoid recreating lots and lots of Intl.Segmenter
  @getDerivedStateFromProps: (nextProps, currentState) ->
    if nextProps.languageCode != currentState.languageCode
      if Segmenter.intlSegmenterSupported()
        intlSegmenter = new Intl.Segmenter(nextProps.languageCode, { granularity: 'word' })
      else
        intlSegmenter = undefined

      newState =
        languageCode:  nextProps.languageCode
        intlSegmenter: intlSegmenter
    else
      newState = {}

    newState

  # Handles the focusing/unfocusing using the Tab key
  handleKeyboardEvent: (e) ->
    if e.target.id == 'target-area' && e.key == 'Tab'
      switch e.type
        # Keyup: the event ENDS in the target area, so we select the text
        when 'keyup'   then @props.selectTargetText()
        # Keydown: the event STARTS in the target area, so we unselect the text
        when 'keydown' then @props.unselectTargetText()

  render: ->
    # Not focusable if no translation is displayed
    tabIndex = if @props.targets.length then '0' else '-1'

    <div id="target-area"
         ref={@props.targetRef}
         tabIndex={tabIndex}
         onKeyDown={@handleKeyboardEvent}
         onKeyUp={@handleKeyboardEvent}>
      {@renderTargetContent()}
      {@renderAlternatives()}
      {@renderLimitWarning()}
      {@renderEnginesDropdown()}
      {@renderTargetCopyButton()}
      {@renderSpinner()}
    </div>

  renderTargetContent: ->
    renderedSentences = @props.targets.map((sentence, index) =>
      if sentence.trim().length
        <TargetSentence key="#{index}-#{sentence}"
                        sentence={sentence}
                        sourceSentence={@props.sources[index] || ''}
                        proofreading={@props.proofreading}
                        index={index}
                        active={@props.activeSentenceIndex == index}
                        activeWordIndex={@props.activeWordIndex}
                        languageCode={@props.languageCode}
                        direction={@props.direction}
                        loading={@props.loading}
                        intlSegmenter={@state.intlSegmenter}
                        wordAlternatives={@props.wordAlternatives}
                        wordAlternativesLoading={@props.wordAlternativesLoading}
                        setActiveSentence={@props.setActiveSentence}
                        setActiveWord={@props.setActiveWord}
                        selectWordAlternative={@props.selectWordAlternative} />
      else
        sentence
    )

    <div id="target-content"
         ref={@props.targetContentRef}
         dir={@props.direction}
         lang={@props.languageCode}
         className={@props.fontSizeClass}>
      {renderedSentences}
      {@renderLoadingDots()}
    </div>

  renderLoadingDots: ->
    # Loading dots are always present, but only made visible when actually loading.
    # This is to avoid line jumps and height-resize jumps in the interface.
    # N.B they should not be visible when a limit warning alert is already shown.
    <LoadingDots visible={@props.loading && @props.limitWarningCode.length == 0} />

  renderAlternatives: ->
    # Only keep alternatives that are not the current translation.
    # Should only happen in race conditions when target arrives before alternatives (unlikely!)
    alternatives = @props.alternatives.filter((alternativeTargets) =>
      !_.isEqual(@props.targets, alternativeTargets)
    )

    <Alternatives alternatives={alternatives}
                  selectAlternative={@props.selectAlternative}
                  languageCode={@props.languageCode}
                  direction={@props.direction}
                  i18n={@props.i18n} />

  renderLimitWarning: ->
    if @props.limitWarningCode.length
      <LimitWarning targets={@props.targets}
                    limitWarningCode={@props.limitWarningCode}
                    lastLimitedAt={@props.lastLimitedAt}
                    limitedDurations={@props.limitedDurations}
                    charLimit={@props.charLimit}
                    assets={@props.assets}
                    paths={@props.paths}
                    currentUser={@props.currentUser}
                    scrollToPricing={@props.scrollToPricing}
                    openCheckoutModal={@props.openCheckoutModal}
                    i18n={@props.i18n.limitWarning} />

  renderEnginesDropdown: ->
    <EngineDropdown engines={@props.engines}
                    topEngines={@props.topEngines}
                    engine={@props.engine}
                    selectEngine={@props.selectEngine}
                    removeTopEngine={@props.removeTopEngine}
                    scrollToPricing={@props.scrollToPricing}
                    i18n={@props.i18n.engineDropdown} />

  renderTargetCopyButton: ->
    <TargetCopyButton targets={@props.targets}
                      loading={@props.loading}
                      currentUser={@props.currentUser}
                      proofreading={@props.proofreading}
                      i18n={@props.i18n.targetCopyButton} />

  renderSpinner: ->
    if @props.loading
      <div className="target-loading-spinner">
        <span className="btn">
          <i className="fas fa-spinner fa-spin" />
        </span>
      </div>
